import { File } from './file';
import { User } from './user';

export class BusinessEntityUser extends User {
  has_root: boolean = false;
  has_create: boolean = false;
  has_write: boolean = false;
  has_read: boolean = false;
}

export class BusinessEntity {
  constructor(
    public business_entity_id: string = '',
    public name: string = '',
    public nameEdition: boolean = false,
    public created_by: string | null,
    public updated_at: Date | null,
    public created_at: Date | null,
    public request_count: string | null,
    public file_set: File[] = [],
    public originalName: string = '',
    public has_root_access: boolean = false,
    public users: BusinessEntityUser[] = []
  ) {
    this.originalName = this.name;
  }
}
